export default "__VITE_PUBLIC_ASSET__80b810d4__"